import React from 'react';

import { CLIVE_GRADIENTS } from '~/components/Clive/cliveRegistry';

import CardDialog from '../../CardDialog';

interface CliveAlertDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
}

const CliveAlertDialog: React.FC<React.PropsWithChildren<CliveAlertDialogProps>> = ({
  isOpen,
  onClose,
  title,
  children,
}) => {
  return (
    <CardDialog
      isDialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      height="fit-content"
      title={title}
      titleVariant="subtitle1"
      classes={{
        paper: CLIVE_GRADIENTS.dialog,
      }}
    >
      {children}
    </CardDialog>
  );
};
export default CliveAlertDialog;
